<template>
  <div class="comments-widget">
    <WidgetWrapp
      class="comments-widget__wrapp"
      title="Новые комментарии"
    >
      <div
        v-for="comment in commentsLast"
        :key="comment.id"
        class="comments-widget__item"
      >
        <CommentPreview
          :comment="comment"
          @comment-click="sendAnalytics"
          @to-comment-click="sendAnalytics"
        />
        <div class="comments-widget__separator" />
      </div>
    </WidgetWrapp>
    <BestComment
      v-if="commentsBest && commentsBest.length"
      :comment="commentsBest[0]"
      class="comments-widget__best-comment"
    />
  </div>
</template>

<script lang="ts">
  import type { PropType } from 'vue';
  import WidgetWrapp from './WidgetWrapp.vue';
  import CommentPreview from '~/components/CommentsWidget/CommentPreview.vue';
  import BestComment from '~/components/CommentsWidget/BestComment.vue';
  import type { TWidgetComment } from '~/types/common';
  import getSlugFromUrl from '~/utils/getSlugFromUrl';

  export default defineNuxtComponent({
    name: 'CommentsWidget',

    components: {
      CommentPreview,
      BestComment,
      WidgetWrapp,
    },

    inject: {
      // Категория в которой происходит событие
      // Для аналитики
      eventCategory: {
        default() {
          return () => '';
        },
      },
    },

    props: {
      last: {
        type: Array as PropType<TWidgetComment[]>,
        default: null,
      },

      top: {
        type: Object as PropType<TWidgetComment>,
        default: null,
      },
    },

    async setup(props) {
      if (props.last || props.top) return;
      const { $api } = useNuxtApp();

      const { data } = await useAsyncData('sidebar-comments', async () => {
        const [best, last] = await Promise.all([
          $api.talker.fetchBestComments(),
          $api.talker.fetchLastComments(),
        ]);

        return { best, last };
      });

      return {
        lastComments: data.value?.last,
        bestComments: data.value?.best,
      };
    },

    data() {
      return {
        comments: {
          last: [] as TWidgetComment[],
          top: [] as TWidgetComment[],
        },
      };
    },

    computed: {
      commentsBest(): TWidgetComment[] {
        return this.top ? [this.top] : this.comments.top;
      },

      currentSlug(): string {
        return getSlugFromUrl(useRoute().fullPath);
      },

      commentsLast(): TWidgetComment[] {
        return this.last ? this.last : this.comments.last;
      },
    },

    methods: {
      // Функция для аналитики клика на комментарий в сайдбаре
      sendAnalytics(link: string) {
        this.$sendYandexMetrika({
          level1: 'Клик_новые_комментарии',
          level4: link,
        });
      },
    },
  });
</script>

<style lang="scss" scoped>
  .comments-widget {
    &__wrapp {
      position: relative;
      :not(:last-child) {
        .comments-widget__separator {
          position: absolute;
          background: $border-color--2;
          height: 1px;
          width: calc(100% - 48px);
          margin: 0 auto;
          left: 0;
          right: 0;
        }
      }
    }
  }
</style>
